module.exports = __webpack_public_path__ + "assets/img/topicon (5).dfd0c010.svg";